// index

let dt_imports = null;

export function index(){
    
    dt_imports = $('#imports_table').DataTable({
        ajax: {
            url: $('#imports_table').attr('url'),
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_actions },
            { width: '120', data: 'updated_at', orderable: true, searchable: false, render: datatables.render_datetime },
            { width: '150', data: 'type', orderable: false, searchable: false, render: render_type },
            { width: '80', data: 'date', orderable: true, searchable: false, render: render_date },
            { data: 'subject', orderable: false, searchable: false, defaultContent: '' },
            { width: '80', data: 'status', orderable: false, searchable: false, render: render_status },
            { data: 'user_fullname', orderable: false, searchable: true, defaultContent: '' },
            { data: 'client.name', orderable: false, searchable: true, defaultContent: '', visible: false },
            { data: 'provider.name', orderable: false, searchable: true, defaultContent: '', visible: false },
            { data: 'user.name', orderable: false, searchable: true, defaultContent: '', visible: false },
            { data: 'user.surname', orderable: false, searchable: true, defaultContent: '', visible: false },
        ],
        order: [[2, 'desc']],
        pageLength: 50,
    });

    dt_imports.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_imports"]').click(batch_delete_imports);
    });
    
}

export function index_force_reload(){

    dt_imports.column(0).checkboxes.deselectAll();
    dt_imports.ajax.reload();

}

function render_actions(data, type, row){
    
    const url_info = 
        ($('#imports_table').attr('url_info').split('|').reduce((acc, item) => {
            const [key, value] = item.split('=');
            acc[key] = value;
            return acc;
        }, {})[row.type] || '')
        .replace('#import_id', row.id)
        .replace('#client_id', row.client_id || '')
        .replace('#provider_id', row.provider_id || '');
    
    const actions = 
        '<div class="btn-group" role="group">' +
            (url_info != '' ? '<a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' : '') +

        '</div>';
    
    return actions;
}

function render_date(data, type, row){
    if(row.date == null){
        return '-';
    } else {
        return datatables.render_date(data, type, row);
    }
}

function render_type(data, type, row){
    switch(row.type){
        case 'client_order':
            return window.__('Pedido de cliente');
        case 'provider_offer':
            return window.__('Oferta de proveedor');
        case 'stock':
            return window.__('Stock propio');
    }
}

function render_status(data, type, row){
    switch(row.status){
        case 'analysis':
            return '<span class="badge bg-light">' + window.__('analizando') + '</span>';
        case 'creating':
            return '<span class="badge bg-light">' + window.__('preparación') + '</span>';
        case 'pending':
            return '<span class="badge bg-info">' + window.__('pendiente') + '</span>';
        case 'processing':
            return '<span class="badge bg-primary">' + window.__('en proceso') + '</span>';
        case 'completed':
            return '<span class="badge bg-success">' + window.__('completado') + '</span>';
        case 'failed':
            return '<span class="badge bg-danger">' + window.__('error') + '</span>';
    }
}

function batch_delete_imports(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['rinfresco.imports.batch_delete'];
    
    let imports_id = [];
    $.each(rows_selected, function(index, rowId){
        imports_id.push(rowId);
    });
    
    if(imports_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna importación'));

    } else {

        const title = __('Eliminar importaciones');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una importación.|[2,*] Estás a punto de eliminar :count importaciones.', imports_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    for(let import_id of imports_id){
                        formData.append('imports_id[]', import_id);
                    }

                    window.ajax.post(route, formData);
                    table.column(0).checkboxes.deselectAll();

                }, 
                _ => {}
            );

    }

}

// show

export function show(){

}
